"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelkomBijCuranovaZorg() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="welkom-bij-curanova-zorg" className="relative py-24 lg:py-32 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-[0.02] pointer-events-none select-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/curanova_logo_watermark.png" alt="" className="w-[600px] md:w-[800px] h-auto object-contain" aria-hidden="true" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Badge variant="secondary" className="mb-8 bg-primary/10 text-primary hover:bg-primary/20 border-transparent text-sm px-4 py-1.5 rounded-full font-medium tracking-wide">
          Wie wij zijn
        </Badge>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-foreground mb-8 tracking-tight">
          Welkom bij CuraNova Zorg
        </h2>

        <div className="max-w-[800px] space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
          <p>
            Bij CuraNova Zorg geloven we dat de beste zorg begint met oprechte
            aandacht voor de mens achter de zorgvraag. Wij bieden hoogwaardige,
            persoonsgerichte zorg en ondersteuning in uw eigen vertrouwde
            thuisomgeving. Of het nu gaat om psychogeriatrische zorg zoals bij
            dementie, ondersteuning bij psychische problematiek, of dagelijkse
            begeleiding en verzorging; wij stemmen onze zorgverlening volledig
            af op uw persoonlijke situatie, wensen en gewoonten.
          </p>
          <p>
            Kwaliteit, veiligheid en respect staan bij ons centraal. Wij werken
            met gediplomeerde zorgprofessionals en streven ernaar om zoveel
            mogelijk met vaste gezichten te werken. Zo bouwen we aan een
            vertrouwensband en garanderen we continuïteit. Daarbij houden we
            altijd rekening met uw religieuze, culturele en persoonlijke
            achtergrond, zodat u zich echt gehoord en begrepen voelt.
          </p>
        </div>

        <div className="mt-16">
          <p className="font-serif italic text-3xl md:text-4xl text-primary/80 tracking-wide">
            Zorg met een hart
          </p>
        </div>
      </div>
    </section>;
}